










































































































































































































































import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import FileDetailNavigationDrawer from '@/components/storage/drawers/FileDetailNavigationDrawer.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import ShowFilePreviewModal from '@/components/storage/modals/ShowFilePreviewModal.vue';
import { FindDirectoryFileDetail,FindDirectoryDetail, findDirectoryQueryDto } from '@/@types/Directory';
import { vxm } from '@/store';
import { FileInfo } from '@/@types/File';

@Component({
  components: {
    FileDetailNavigationDrawer,
    AccountIcon,
    ShowFilePreviewModal,
  },
})
export default class TableView extends Vue {
  @Model('change', {type: Array})
  private readonly checkBoxArray!: Array<number>;

  @Prop({ required: true })
  private searchWord!: string;

  private isSelectDetailTab: boolean = true;
  private isSelectHistoryTab: boolean = false;
  private filterSelectedContents: Array<number> = [];
  private isOpenPropertydrawer: boolean = false;
    // 矢印が上下どちらを向いているか
  private nameArrowMoveStatus: boolean = false;
  private updateArrowMoveStatus: boolean = false;
  private updaterArrowMoveStatus: boolean = false;
  private typeArrowMoveStatus: boolean = false;
  private sizeArrowMoveStatus: boolean = false;
  // ソート機能をクリックしたかどうか
  private nameClickStatus: boolean = false;
  private updateClickStatus: boolean = false;
  private updaterClickStatus: boolean = false;
  private typeClickStatus: boolean = false;
  private sizeClickStatus: boolean = false;
  private currentArrowName: string | null = null;
  private arrowFreeze: boolean = true;

  private fileId: number = 0;
  private fileName: string = '';
  private isShowFilePreviewModal: boolean = false;

  private fileInfo: FileInfo | null = null;
  private objectType: string = '';
  private objectName: string = '';
  private objectSize: string = '';
  private objectPath: string = '';
  private objectOwner: string = '';
  private objectChangeDate: Date = new Date();
  private objectChanger: string = '';
  private objectOwnerIcon: string = '';
  private objectChangerIcon: string = '';

  private showDetail(): void {
    this.isSelectDetailTab = true;
    this.isSelectHistoryTab = false;
  }

  private showHistory(): void {
    this.isSelectDetailTab = false;
    this.isSelectHistoryTab = true;
  }

  private selectedDirectoryPutArray(index: number): Array<number> {
    if (this.checkBoxArray.includes(index)) {
      const checkIndex: number = this.checkBoxArray.indexOf(index);
      return this.checkBoxArray.splice(checkIndex, 1);
    } else {
      this.checkBoxArray.push(index);
      return this.checkBoxArray;
    }
  }

  private selectedFilePutArray(index: number): Array<number> {
    const fileIndex = index + this.directories.length;
    if (this.checkBoxArray.includes(fileIndex)) {
      const checkIndex: number = this.checkBoxArray.indexOf(fileIndex);
      return this.checkBoxArray.splice(checkIndex, 1);
    } else {
      this.checkBoxArray.push(fileIndex);
      return this.checkBoxArray;
    }
  }

  private isSelectedDirectory(index: number): boolean {
    if (this.checkBoxArray.includes(index)) {
      return true;
    } else {
      return false;
    }
  }

  private isSelectedFile(index: number): boolean {
    if (this.checkBoxArray.includes(index + this.directories.length)) {
      return true;
    } else {
      return false;
    }
  }

  private getExtensionName(fileName: string) {
    const startIndex = fileName.lastIndexOf('.');
    if (startIndex === -1) {
      return '';
    }
    return fileName.slice(startIndex + 1);
  }

  private showArrowAction(type: string): void {
    const changeClass: NodeListOf<HTMLElement> = document.getElementsByName(type);
    if (
      (type === 'name' && this.nameClickStatus === false) ||
      (type === 'update' && this.updateClickStatus === false) ||
      (type === 'updater' && this.updaterClickStatus === false) ||
      (type === 'type' && this.typeClickStatus === false) ||
      (type === 'size' && this.sizeClickStatus === false)
    ) {
      changeClass[0].classList.remove('arrow-hide-animation');
      changeClass[0].classList.remove('arrow-hide');
      changeClass[0].classList.add('arrow-show-animation');
    }
  }

  private hideArrowAction(type: string): void {
    const changeClass: NodeListOf<HTMLElement> = document.getElementsByName(type);
    if (
      (type === 'name' && this.nameClickStatus === false) ||
      (type === 'update' && this.updateClickStatus === false) ||
      (type === 'updater' && this.updaterClickStatus === false) ||
      (type === 'type' && this.typeClickStatus === false) ||
      (type === 'size' && this.sizeClickStatus === false)
    ) {
      changeClass[0].classList.remove('arrow-show-animation');
      changeClass[0].classList.add('arrow-hide-animation');
      changeClass[0].classList.add('arrow-hide');
    }
  }

  private changeArrowStatus(type: string): void {
    // 今矢印が出ている要素を検出して矢印を消すかどうか
    if (this.currentArrowName !== null && this.currentArrowName !== type) {
      const deleteClassName: NodeListOf<HTMLElement> = document.getElementsByName(this.currentArrowName);
      deleteClassName[0].classList.remove('arrow-show-animation');
      deleteClassName[0].classList.remove('arrow-deg-animation');
      deleteClassName[0].classList.remove('arrow-strong');
      deleteClassName[0].classList.add('arrow-hide');

      if (this.currentArrowName === 'name') {
        this.nameClickStatus = false;
        this.nameArrowMoveStatus = false;
      } else if (this.currentArrowName === 'update') {
        this.updateClickStatus = false;
        this.updateArrowMoveStatus = false;
      } else if (this.currentArrowName === 'updater') {
        this.updaterClickStatus = false;
        this.updaterArrowMoveStatus = false;
      } else if (this.currentArrowName === 'type') {
        this.typeClickStatus = false;
        this.typeArrowMoveStatus = false;
      } else if (this.currentArrowName === 'size') {
        this.sizeClickStatus = false;
        this.sizeArrowMoveStatus = false;
      }
    }
    const addDegClassName: NodeListOf<HTMLElement> = document.getElementsByName(type);
    addDegClassName[0].classList.add('arrow-strong');

    // クリックした項目の矢印恒久表示と消去～回転挙動
    // 各項目のソート初回は回転させない
    if (this.currentArrowName !== type) {
      this.currentArrowName = type;
      this.arrowFreeze = true;
    }

    if (this.arrowFreeze === false) {
      addDegClassName[0].classList.remove('arrow-deg-animation');
      addDegClassName[0].classList.add('arrow-undeg-animation');
    } else {
      this.arrowFreeze = false;
    }

    // この中にあるソートの構文はダミーなのでDB繋がったら変更すること
    if (type === 'name') {
      this.nameClickStatus = true;
      if (this.nameArrowMoveStatus === false) {
        this.nameArrowMoveStatus = true;
      } else {
        this.nameArrowMoveStatus = false;
        addDegClassName[0].classList.remove('arrow-deg');
        addDegClassName[0].classList.remove('arrow-undeg-animation');
        addDegClassName[0].classList.add('arrow-deg-animation');
      }
    } else if (type === 'update') {
      this.updateClickStatus = true;
      if (this.updateArrowMoveStatus === false) {
        this.updateArrowMoveStatus = true;
      } else {
        this.updateArrowMoveStatus = false;
        addDegClassName[0].classList.remove('arrow-deg');
        addDegClassName[0].classList.remove('arrow-undeg-animation');
        addDegClassName[0].classList.add('arrow-deg-animation');
      }
    } else if (type === 'updater') {
      this.updaterClickStatus = true;
      if (this.updaterArrowMoveStatus === false) {
        this.updaterArrowMoveStatus = true;
      } else {
        this.updaterArrowMoveStatus = false;
        addDegClassName[0].classList.remove('arrow-deg');
        addDegClassName[0].classList.remove('arrow-undeg-animation');
        addDegClassName[0].classList.add('arrow-deg-animation');
      }
    } else if (type === 'type') {
      this.typeClickStatus = true;
      if (this.typeArrowMoveStatus === false) {
        this.typeArrowMoveStatus = true;
      } else {
        this.typeArrowMoveStatus = false;
        addDegClassName[0].classList.remove('arrow-deg');
        addDegClassName[0].classList.remove('arrow-undeg-animation');
        addDegClassName[0].classList.add('arrow-deg-animation');
      }
    } else if (type === 'size') {
      this.sizeClickStatus = true;
      if (this.sizeArrowMoveStatus === false) {
        this.sizeArrowMoveStatus = true;
      } else {
        this.sizeArrowMoveStatus = false;
        addDegClassName[0].classList.remove('arrow-deg');
        addDegClassName[0].classList.remove('arrow-undeg-animation');
        addDegClassName[0].classList.add('arrow-deg-animation');
      }
    }
  }

  private onSizeUnit(size: number, loop: number = 1): string {
    if (size > 1024) {
      loop++;
      return this.onSizeUnit(size / 1024, loop);
    }
    const unit: {[key: number]: string} = {
      1: 'B',
      2: 'KB',
      3: 'MB',
      4: 'GB',
      5: 'TB',
      6: 'PB',
    };
    return Math.floor(size) + unit[loop];
  }

  private openShowFilePreviewModal(file: FindDirectoryFileDetail): void {
    this.fileId = file.fileId;
    this.fileName = file.fileName;
    this.isShowFilePreviewModal = true;
  }

  private closeShowFilePreviewModal() {
    this.isShowFilePreviewModal = false;
  }

  private switchDirectoryDetailDrawer(directory: FindDirectoryDetail): void {
    if (!this.isOpenPropertydrawer) {
      this.objectType = 'Directory' ;
      this.objectName = directory.directoryName;
      this.objectSize = '';
      this.getDirectoryPathFromParent(directory.parentDirectoryId); // this function will update this.objectPath
      this.objectOwner = directory.accountName;
      this.objectOwnerIcon = '';
      if (directory.updateAccountName) {
        this.objectChanger = directory.updateAccountName;
        this.objectChangerIcon = '';
      } else {
        this.objectChanger = directory.accountName;
        this.objectChangerIcon = '';
      }
      if (directory.updatedAt) {
        this.objectChangeDate = directory.updatedAt
      } else {
        this.objectChangeDate = directory.createdAt
      }
      this.objectChangeDate = new Date(this.objectChangeDate);
    }
    this.isOpenPropertydrawer = !this.isOpenPropertydrawer;
  }

  private async getDirectoryPathFromParent(parentDirectoryId: number | null) {
    const query: findDirectoryQueryDto = {
      'project-id':vxm.theoryApi.authStore.getCurrentProjectId!
    };
    let currentDirectory: FindDirectoryDetail | undefined = undefined;
    let path: string = '';

    while (parentDirectoryId) {
      await vxm.theoryApi.directoriesStore.fetchParentDirectory({directoryId:parentDirectoryId,query:query});
      if (vxm.theoryApi.directoriesStore.getParentDirectory) {
        currentDirectory = vxm.theoryApi.directoriesStore.getParentDirectory.results;
        parentDirectoryId = currentDirectory.parentDirectoryId;
        path = `${currentDirectory.directoryName}\\${path}`;
      }
    }
    path = `\\\\${path}`;
    this.objectPath = path;
  }

  private async getDirectoryPathFromCurrent(currentDirectoryId: number) {
    const query: findDirectoryQueryDto = {
      'project-id':vxm.theoryApi.authStore.getCurrentProjectId!
    };
    let currentDirectory: FindDirectoryDetail | undefined = undefined;
    let parentDirectoryId: number | null = null;
    let path: string = '';

    await vxm.theoryApi.directoriesStore.fetchParentDirectory({directoryId:currentDirectoryId,query:query});
    if (vxm.theoryApi.directoriesStore.getParentDirectory) {
      currentDirectory = vxm.theoryApi.directoriesStore.getParentDirectory.results;
      parentDirectoryId = currentDirectory.parentDirectoryId;
      path = currentDirectory.directoryName;
      while (parentDirectoryId) {
        await vxm.theoryApi.directoriesStore.fetchParentDirectory({directoryId:parentDirectoryId,query:query});
        if (vxm.theoryApi.directoriesStore.getParentDirectory) {
          currentDirectory = vxm.theoryApi.directoriesStore.getParentDirectory.results;
          parentDirectoryId = currentDirectory.parentDirectoryId;
          path = `${currentDirectory.directoryName}\\${path}`;
        }
      }
      path = `\\\\${path}\\`;
      this.objectPath = path;
    }
  }

  private switchFileDetailDrawer(file: FindDirectoryFileDetail): void {
    if (!this.isOpenPropertydrawer) {
      vxm.theoryApi.filesStore.fetchFileInfo({fileId:file.fileId,projectId:vxm.theoryApi.authStore.getCurrentProjectId!}).then(() => {
        const fileInfo = vxm.theoryApi.filesStore.getFileInfo;
        if (fileInfo) {
          this.objectName = fileInfo.fileName;
          this.objectType = this.getFileExtension(fileInfo?.fileName)!.toUpperCase() ;
          this.getDirectoryPathFromCurrent(fileInfo.directoryId!).then(()=> { // this function will update this.objectPath
            if (fileInfo) {
              if (fileInfo.accountName) {
                this.objectOwner = fileInfo.accountName;
                this.objectOwnerIcon = fileInfo.iconImage;
                this.objectChanger = fileInfo.accountName;
                this.objectChangerIcon = fileInfo.iconImage;
              } else {
                this.objectOwner = '';
                this.objectOwnerIcon = '';
                this.objectChanger = '';
                this.objectChangerIcon = '';
              }
              if (fileInfo.updatedAt) {
                this.objectChangeDate = fileInfo.updatedAt;
              } else {
                this.objectChangeDate = fileInfo.createdAt;
              }
              this.objectChangeDate = new Date(this.objectChangeDate);
            }
          });
        }
        this.objectSize = '';
      });
    }
    this.isOpenPropertydrawer = !this.isOpenPropertydrawer;
  }

  private getFileExtension(fileName:string) {
    const ext = fileName.match(/[^.]+$/);
    if (ext) {
      return ext.toString();
    }
  }

  private closeDetailDrawer(): void {
    this.isOpenPropertydrawer = false;
  }

  private get directories() {
    const directories = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles?.results.directories ?? [];
    return this.searchWord ? directories.filter((d) => d.directoryName.includes(this.searchWord)) : directories;
  }

  private get files() {
    const files = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles?.results.files ?? [];
    return this.searchWord ? files.filter((f) => f.fileName.includes(this.searchWord)) : files;
  }
}
